export const OPTIONS_TABS = [
  { label: 'Information', value: 'information' },
  { label: 'History', value: 'history' },
];
